import right_input from "./right_input.png"
import left_input from "./left_input.png"
import xbox from "./x-box.png"

export const images = {
right_input,
left_input,
xbox
}